class SmzDiag {
    constructor(el, options = {}) {
        this.returnButtonField = document.querySelector(".btn-return-field");
        this.returnButton = document.querySelector(".btn-return");
        this.content = el;
        this.view = "";

        this.diagContent = el;
        this.stepCurrent = 0;
        this.diagData = {};
        this.paramString = "",
            this.searchparam = new URLSearchParams("index", this.paramString);
        this.customerData = {};
        this.customerAge = "";
        this.objectInfo = {};
        this.customerCible = "";
        this.customerProb = "";
        this.toolId = 0;
        this.zoneCible = {
            Rides_du_lion: {
                text: "Utilisez un Gua Sha chaque soir pour masser le visage en insistant sur le front. Nos facialistes vous conseillent d’effectuer un lissage de la ride du lion vers le haut et d’utiliser la pointe du Gua Sha pour réaliser des frictions / mouvements circulaires ciblés dont l’objectif est de défroisser la ride du Lion. Avec la partie crantée du Gua Sha Jade vous pouvez également gommer votre ride du lion par des mouvements de va-et-viens en tenant le Gua Sha perpendiculairement à la ride. Le massage permettra de lisser la ride, booster la pénétration des actifs dans les couches de la peau et de relancer la production de collagène. ",
                number: 1,
                src: "https://cdn.shopify.com/videos/c/o/v/7562ca75e89b442fa0286a0911a570ef.mp4"
            },
            Patte_oie: {
                text: "Après avoir appliqué votre contour des yeux, massez la zone du regard en effectuant des mouvements de lissage de l’intérieur vers l’extérieur. Utilisez ensuite vos deux mains pour étirer la zone de la patte d’oie afin de lisser rides et ridules - trop technique je pense. Que penses-tu de : effectuer de légers pincements toniques sur les rides pour stimuler la production de collagène. Le massage permettra de booster la pénétration des actifs dans les couches de la peau tout en ouvrant le regard. ",
                number: 2,
                src: "https://cdn.shopify.com/videos/c/o/v/8db8bbb7f554493fb3872861ce1ea424.mp4"
            },
            Ovale_du_visage: {
                text: "Effectuez un lissage profond de l’ovale du visage vers la zone ganglionnaire située à la base des clavicules et sculptez l’ovale du visage à l’aide du tranchant du Gua Sha en effectuant un lissage du menton vers les oreilles. Le massage permettra de booster la pénétration des actifs dans les couches de la peau et de relancer la production de collagène.",
                number: 3,
                src: "https://cdn.shopify.com/videos/c/o/v/31738abd2c9a48aab28d80a636bb4ead.mp4"
            },
            Rides_péribuccales: {
                text: "Après avoir appliqué une huile sur l’ensemble du visage, pincez délicatement les lèvres entre le plat du pouce et de l’index pour les détendre et les repulper / effectuez des petits pincements toniques entre le pouce et l’index sur toutes les rides du contour de la bouche. Utilisez ensuite la pointe d’un Gua Sha pour lisser la peau et estomper les ridules en maintenant bien les tissus.",
                number: 4,
                src: "https://cdn.shopify.com/videos/c/o/v/a29fe7d7df8b4a5393531bfca8df082b.mp4"
            },
            Sillon_nasogénien: {
                text: "Après avoir appliqué une huile sur l’ensemble du visage, utilisez la pointe d’un Gua Sha comme un stylo et effectuez des mouvements circulaires afin de décongestionner et stretcher la zone. Le massage permettra de booster la pénétration des actifs dans les couches de la peau et de relancer la production de collagène.",
                number: 5,
                src: "https://cdn.shopify.com/videos/c/o/v/7b63f67103ab404997df68239af30484.mp4"
            },
            Rides_du_cou: {
                text: "Après avoir appliqué une huile sur l’ensemble du visage et du cou, utilisez le plat d’un Gua Sha pour effectuer un lissage profond vers les clavicules. Utilisez la partie crantée du Gua Sha Jade et gommez les rides par des mouvements de va-et-viens en tenant le Gua Sha perpendiculairement à chaque ride. Le massage permettra de booster la pénétration des actifs dans les couches de la peau et de relancer la production de collagène.",
                number: 6,
                src: "https://cdn.shopify.com/videos/c/o/v/d479725e67d64e75890c3e557beee7f0.mp4"
            },
            Les_pomettes: {
                text: "Après avoir appliqué une huile sur l’ensemble du visage, réalisez des battages dynamiques - je ne suis pas sûre que tout le monde comprenne battages, que penses-tu de “crochetez les pommettes entre l’index et le majeur et lissez vers le haut” pour tonifier la peau et stimuler la production de collagène, utilisez ensuite le bord lisse d’un Gua Sha pour redessiner les pommettes. Le massage permettra de booster la pénétration des actifs dans les couches de la peau et de relancer la production de collagène.",
                number: 7,
                src: "https://cdn.shopify.com/videos/c/o/v/42bf4cd7242a463aa7607e16b11c9ee2.mp4"
            },
            Cernes_poches: {
                text: "Utilisez un mushroom chaque soir après avoir appliqué votre contour des yeux et lissez la peau en effectuant un mouvement de l’intérieur vers l’extérieur afin de drainer la lymphe. Pour plus d’efficacité et un effet décongestionnant immédiat, nos facialistes vous conseillent de conserver votre mushroom au réfrigérateur.",
                number: 8,
                src: "https://cdn.shopify.com/videos/c/o/v/dd52074ed1e247a3864e5d8c47fb8a0b.mp4"
            }
        };

        this.probObject = {};
        this.probInfo = {
            teintTerne: {
                key: 1,
                product: 1,
                title: "Teint terne",
                text: "Changement de saison, bouleversement hormonal, stress, déshydratation… nombreuses sont les raisons qui peuvent entraîner un manque d’éclat mais il est tout à fait possible d’y remédier en intégrant à sa routine certains actifs tels que la Vitamine C et en exfoliant la peau régulièrement avec des produits enrichis en AHAs comme l’acide glycolique ou lactique."
            },
            RidesRidules: {
                key: 2,
                product: 2,
                title: "Rides, ridules",
                text: "Premiers signes du vieillissement cutané, les rides et ridules marquent généralement la peau aux endroits les plus sollicités au quotidien. Au coin des yeux pour la ride de la patte d’oie, au coin des lèvres pour la ride du sillon nasogénien ou encore au milieu du front pour la ride du lion, ces lignes plus ou moins creuses sont symptomatiques d’une baisse de la production de collagène et d’élastine. D’autres facteurs tels que la déshydratation ou le stress peuvent accentuer ce phénomène et doivent également être pris en compte pour traiter au mieux cette problématique. "
            },
            CernePoches: {
                key: 3,
                product: 3,
                title: "Cernes, poches",
                text: "Manque de sommeil, vieillissement cutané, mauvaise circulation sanguine ou génétique… il est parfois difficile de se débarrasser des cernes et des poches qui peuvent assombrir le regard et donner un air fatigué. Si certains actifs comme la caféine sont reconnus pour leurs capacités à booster la microcirculation sanguine, nos facialistes recommandent d’y associer quelques gestes de massage avec ou sans accessoire pour décongestionner les poches et estomper les cernes. "
            },
            pigmentation: {
                key: 4,
                product: 4,
                title: "Taches pigmentaires ou cicatrices superficielles",
                text: "Les taches pigmentaires, également appelées taches brunes, sont le résultat d'une surproduction de mélanine dans certaines zones de la peau. Elles peuvent être dues à des expositions prolongées au soleil sans protection, ce qui entraîne une hyperpigmentation localisée. Les facteurs génétiques et hormonaux peuvent également contribuer à l'apparition de taches."
            },
            imperfections: {
                key: 5,
                product: 5,
                title: "Imperfections",
                text: "Stress, dérèglement du microbiome cutané ou troubles hormonaux, les imperfections sont le plus souvent l’expression d’un déséquilibre interne et il peut être difficile de les traiter durablement. Situées sur le front, les joues ou sur la mâchoire, l’emplacement des imperfections en dit beaucoup sur leur origine et vous aident à trouver un traitement adapté (changement de routine, d’alimentation, stress…)."
            },
            sebum: {
                key: 6,
                product: 6,
                title: "Excès de sébum",
                text: "L’excès de sébum est une problématique fréquente des peaux grasses mais cela peut également apparaître lorsque la peau est agressée. À cause de cette surproduction de sébum ; la peau devient brillante, inconfortable et il est parfois compliqué de trouver la routine adaptée. Toutefois, ce dérèglement du film hydrolipidique est souvent passager et la production de sébum peut être régulée en utilisant les bons actifs comme le zinc ou la niacinamide par exemple."
            },
            grain: {
                key: 7,
                product: 1,
                title: "Grain de peau irrégulier",
                text: "Fatigue, pollution, imperfections… nombreuses sont les causes qui peuvent entraîner l’apparition d’un grain de peau irrégulier, lui donnant un aspect granuleux et parfois terne. Cette problématique peut, le plus souvent, être traitée en exfoliant régulièrement la peau pour la débarrasser des cellules mortes et ainsi lutter contre l’apparition des imperfections. Certains actifs comme les AHAs sont particulièrement recommandés pour traiter cette problématique de peau. "
            },
            tiraillement: {
                key: 8,
                product: 7,
                title: "Tiraillements, rougeurs",
                text: "Lorsque la peau est sensibilisée, elle devient inconfortable et peut tirailler. Dans certains cas des rougeurs peuvent également apparaître, avec une sensation d’irritation voire de brûlure. Pour lutter contre ces désagréments, il est nécessaire de nourrir et hydrater la peau au quotidien et d’utiliser dans sa routine des actifs aux vertus hydratantes apaisantes. "
            },
            fermeté: {
                key: 9,
                product: 8,
                title: "Manque de fermeté",
                text: "Avec l’âge, la production de collagène et d’élastine diminue et les muscles du visage ont tendance à rétrécir, ce qui entraîne un relâchement cutané global. Si cela est tout à fait normal, ce manque de fermeté peut être retardé par l’utilisation d’une routine adaptée enrichie en actifs liftant par exemple qui, grâce à leur effet tenseur, vont retendre les traits et donner à la peau un aspect plus lisse et rebondi. "
            }
        };

        this.countStep = document.querySelectorAll(".content-step").length;
        this.options = Object.assign(
            {},
            {
                customer: {
                    prenom: "",
                    email: ""
                }
            },
            options
        );

        window.dataLayer = window.dataLayer || [];

        //Events
        document.querySelectorAll(".content-step").forEach((cstep, index) => {
            console.log("cstep", cstep);
            var step = cstep.querySelector(".step");
            // var progressBar = cstep.querySelector(".skill-per");
            // progressBar.style.width = `${index * 5.2632}%`;
            step.setAttribute("data-index", index);
            var type = cstep.getAttribute("data-type");
            var mode = cstep.getAttribute("data-mode");
            var returnButton = step.querySelector(".btn-return");
            if (returnButton) {
                returnButton.addEventListener("click", () => {
                    this.stepCurrent--;
                    this.goToStepBack(this.stepCurrent);
                });
            }
            var returnButtonField = step.querySelector(".btn-return-field");
            if (returnButtonField) {
                returnButtonField.addEventListener("click", () => {
                    this.stepCurrent--;
                    this.goToStepBack(this.stepCurrent);
                });
            }
            /* CHECKBOX */
            if (type == "checkbox") {
                step.querySelectorAll(".reponse").forEach(a => {
                    a.addEventListener("click", () => {

                        if (mode == "solo") {
                            var type = a.getAttribute("data-type");
                            if (type == "scoring") {
                                var dataRoutine = a.getAttribute("data-routine").split(",");
                                var dataScore = parseInt(a.getAttribute("data-score"));
                                /* On vérifie que les routines existes dans notre tableau de scoring */
                                dataRoutine.forEach(d => {
                                    if (typeof this.diagData[d] == "undefined") {
                                        this.diagData[d] = {
                                            "total": 0
                                        }
                                    }
                                });
                                if (!a.classList.contains("select")) {
                                    var allRep = a.closest(".content-reponse").querySelectorAll(".reponse");
                                    allRep.forEach(rep => {
                                        if (rep.classList.contains("select")) {
                                            rep.classList.remove("select");
                                        }
                                    });
                                    dataRoutine.forEach(d => {
                                        this.diagData[d].total += dataScore;
                                    });
                                    console.log("add select class 3");
                                    a.classList.add("select");
                                }
                                var value = a.innerText;
                                var question = a.closest(".step").querySelector(".content-question h2").innerText;
                                this.trackDL(this.stepCurrent, question, value);
                                this.stepCurrent++;
                                this.goToStep(this.stepCurrent, value);
                            }
                            if (type == "customer") {
                                if (!a.classList.contains("select")) {
                                    var allRep = a.closest(".content-reponse").querySelectorAll(".reponse");
                                    allRep.forEach(rep => {
                                        if (rep.classList.contains("select")) {
                                            rep.classList.remove("select");
                                        }
                                    });
                                    var name = a.getAttribute("data-name");
                                    var value = a.getAttribute("data-value");
                                    this.customerData[name] = value;
                                    console.log("add select class");
                                    a.classList.add("select");
                                }
                                var value = a.innerText;
                                var question = a.closest(".step").querySelector(".content-question h2").innerText;
                                this.trackDL(this.stepCurrent, question, value);
                                this.stepCurrent++;
                                this.goToStep(this.stepCurrent, value);
                            }
                        } else {
                            var dataRoutine = a.getAttribute("data-routine").split(",");
                            var dataScore = parseInt(a.getAttribute("data-score"));
                            /* On vérifie que les routines existes dans notre tableau de scoring */
                            dataRoutine.forEach(d => {
                                if (typeof this.diagData[d] == "undefined") {
                                    this.diagData[d] = {
                                        "total": 0
                                    }
                                }
                            });
                            if (!a.classList.contains("select")) {
                                console.log("add select class 2");
                                a.classList.add("select");
                                dataRoutine.forEach(d => {
                                    this.diagData[d].total += dataScore;
                                });
                            } 
                            // if(a.classList.contains("select")) {

                            //     dataRoutine.forEach(d => {
                            //         this.diagData[d].total -= dataScore;
                            //     });
                            // }
                            else {
                                console.log("remove select class 2");
                                a.classList.remove("select");
                                dataRoutine.forEach(d => {
                                    this.diagData[d].total -= dataScore;
                                });
                            }
                        }
                    });
                });

                if (mode == "multiple") {
                    step.querySelector(".btn-confirm").addEventListener("click", () => {
                        if (step.querySelectorAll(".reponse.select").length > 0) {
                            var value = "";
                            var question = step.querySelector(".content-question h2").innerText;
                            step.querySelectorAll(".reponse.select").forEach(r => {
                                value += r.innerText;
                            });
                            this.trackDL(this.stepCurrent, question, value);
                            this.stepCurrent++;
                            this.goToStep(this.stepCurrent, value);
                            this.killError();
                        } else {
                            this.showError("Vous devez séléctionner au moins un champs.", 3500);
                        }
                    });
                }
            }

            /* FIELDS */
            if (type == "field") {
                step.querySelector(".btn-confirm").addEventListener("click", () => {
                    var field = step.querySelector(".field input");
                    var name = field.getAttribute("name");
                    var value = field.value;
                    if (value != "") {
                        this.killError();
                        this.customerData[name] = value;
                        this.trackDL(this.stepCurrent, name, value);
                        this.stepCurrent++;
                        this.goToStep(this.stepCurrent, value);
                    } else {
                        this.showError("Vous devez remplir le champs.", 3500);
                    }
                });
            }

        });
    }

    trackDL(step, question, value) {
        window.dataLayer.push({
            event: 'Diagnostic',
            'data-step': step, // variable dynamique numero étape
            'data-obj': question,  // variable dynamique nom étape 
            'data-value': value  // variable dynamique - libellé sélection
        });
    }

    killError() {
        var errors = document.querySelectorAll(".content-error");
        if (errors.length > 0) {
            errors.forEach(e => {
                e.remove();
            })
        }
    }

    showError(message, time) {
        this.killError();
        var contentError = document.createElement("div");
        contentError.classList.add("content-error");
        var error = document.createElement("div");
        error.classList.add("error");
        error.innerHTML = message;
        contentError.appendChild(error);
        document.querySelector("body").appendChild(contentError);
        setTimeout(() => {
            contentError.classList.add("show");
        }, 100);
        setTimeout(() => {
            contentError.remove();
        }, time);
    }
    goToStepBack(index) {
        document.querySelectorAll(".content-step")[index].closest(".shopify-section").classList.remove("off");

    }
    goToStep(index, value) {
        let indexString = index.toString();
        console.log(indexString);
        this.paramString = indexString;
        this.searchparam.set("index", this.paramString);
        const currentURL = window.location.href;
        const url = new URL(currentURL);
        url.search = this.searchparam.toString();
        history.pushState(null, "", url);
        value = value.trim();
        if (index == 2) {
            this.customerAge = value;
            console.log("age", this.customerAge, value);
            if (index == 2 && value == "Entre 36 et 50 ans" || index == 2 && value == "50 ans et +") {
                sessionStorage.setItem('age', true);
            }
            else{
                sessionStorage.setItem('age', false);
            }
        }

        if (index == 3 && value !== "Moins de 6h") {
            this.stepCurrent++;
            document.querySelectorAll(".content-step")[index].closest(".shopify-section").classList.add("off");
        }
        if (index == 6 && value == "Non, pas vraiment") {
            this.stepCurrent++;
            document.querySelectorAll(".content-step")[index].closest(".shopify-section").classList.add("off");
        }
        if (index == 8 && value == "Non pas particulièrement") {
            this.stepCurrent++;
            document.querySelectorAll(".content-step")[index].closest(".shopify-section").classList.add("off");
        }
        if (index == 10 && this.age) {
            this.stepCurrent++;
            document.querySelectorAll(".content-step")[index].closest(".shopify-section").classList.add("off");
        }
        if (index == 13 && value == "Jamais") {
            this.stepCurrent++;
            document.querySelectorAll(".content-step")[index].closest(".shopify-section").classList.add("off");
        }
        if (index == 16) {
            if (value == "Teint terne") {
                this.probObject = this.probInfo.teintTerne;
            }
            if (value == "Imperfections") {
                this.probObject = this.probInfo.imperfections;
            }
            if (value == "Rides, ridules") {
                this.probObject = this.probInfo.RidesRidules;
            }
            if (value == "Cernes, poches") {
                this.probObject = this.probInfo.CernePoches;
            }
            if (value == "Tiraillement") {
                this.probObject = this.probInfo.tiraillement;
            }
            if (value == "Manque de fermeté") {
                this.probObject = this.probInfo.fermeté;
            }
            if (value == "Taches pigmentaires & cicatrices superficielles") {
                this.probObject = this.probInfo.pigmentation;
            }
            if (value == "Excès de sébum") {
                this.probObject = this.probInfo.sebum;
            }
            if (value == "Grain de peau irrégulier") {
                this.probObject = this.probInfo.grain;
                this.probObject.key = 1;
            }
            if (value == "Tiraillements, rougeurs") {
                this.probObject = this.probInfo.tiraillement;
            }
            if (value == "Manque de fermeté") {
                this.probObject = this.probInfo.fermeté;
            }
            this.customerProb = this.probObject.key;
            sessionStorage.setItem("probs", JSON.stringify(this.probObject));
        }
        if (index == 18) {
            if (value == "Les pommettes") {
                this.toolId = 2;
                this.objectInfo = this.zoneCible.Les_pomettes;
                this.view = "routine_2";
            }
            if (value == "Rides péribuccales") {
                this.toolId = 1;
                this.objectInfo = this.zoneCible.Rides_péribuccales;
                this.view = "routine_1";
            }
            if (value == "Sillon nasogénien") {
                this.toolId = 3;
                this.objectInfo = this.zoneCible.Sillon_nasogénien;
                this.view = "routine_3";
            }
            if (value == "Rides de la patte d'oie") {
                this.toolId = 1;
                this.objectInfo = this.zoneCible.Patte_oie;
                this.view = "routine_1";
            }
            if (value == "Ride du lion, rides du front") {
                this.toolId = 1;
                this.objectInfo = this.zoneCible.Rides_du_lion;
                this.view = "routine_1";
            }
            if (value == "Rides du cou") {
                this.toolId = 3;
                this.objectInfo = this.zoneCible.Rides_du_cou;
                this.view = "routine_3";

            }
            if (value == "Ovale du visage") {
                this.toolId = 1;
                this.objectInfo = this.zoneCible.Ovale_du_visage;
                this.view = "routine_1";
            }
            if (value == "Cernes, poches") {
                this.toolId = 2;
                this.objectInfo = this.zoneCible.Cernes_poches;
                this.view = "routine_2";
            }
            let cible = {
                "key": value,
                "toolId": this.toolId,
                "text": this.objectInfo.text,
                "number": this.objectInfo.number,
                "src": this.objectInfo.src
            }
            this.customerCible = value;
            sessionStorage.setItem("cible", JSON.stringify(cible));
        }
        // document.querySelectorAll(".content-step")[index].closest(".shopify-section").classList.remove("off");
        if (index >= this.countStep) {
            this.result();
        } else {
            document.querySelectorAll(".content-step")[index - 1].closest(".shopify-section").classList.add("off");
            //var scrollTo = document.querySelectorAll(".content-step")[index-1].offsetTop;  
            //this.content.style.transform = `translateY(-${scrollTo}px)`;
        }
    }

    removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    }

    result() {
        var sortable = [];
        console.log("diagData", this.diagData)
        Object.entries(this.diagData).forEach(([key, value]) => {
            sortable.push([key, value.total]);
        });
        console.log("sortable", sortable)
        sortable.sort(function (a, b) {
            return a[1] - b[1];
        });
        var sortableR = sortable.reverse();
        console.log("sortableR", sortableR)
        console.log("sortableR[0][0]", sortableR[0][0])
        if (typeof this.customerData.pregnant != "undefined" && this.customerData.pregnant == "True") {
            window.location.href = "/pages/femme-enceinte";
        } else {
            if (typeof this.customerData.email != "undefined" && typeof this.customerData.prenom != "undefined") {
                // + "&view=" + this.view

                // recup type de crème et gère si le premier cas est vide
                var sortableR_result = sortableR[0][0]

                if (sortableR_result === '' && sortableR[1] !== 'undefined')
                    sortableR_result = sortableR[1][0]

                if (sortableR_result === '')
                    sortableR_result = 'ND'


                var url =sortableR_result + "?mode=diag&prenom=" + this.customerData.prenom + "&problematic=" + this.probObject.key + "&zonecible=" + this.customerCible + "&age=" + this.customerAge + "&view=" + this.view;
                console.log("url", url);
                var routineHandle = sortableR_result.split("/");
                var objToSend = {
                    "prenom": this.customerData.prenom,
                    "routine": routineHandle[routineHandle.length - 1],
                    "Age": this.customerAge,
                    "zoneCible": this.customerCible,
                    "problématique": this.customerProb,
                    "url": `https://seasonly.fr${url}`
                };
                /*_learnq.push(['identify', {'$email': this.customerData.email }]);  
                _learnq.push(['track', 'typeform-diag', objToSend ]);   
                setTimeout(() => {
                    window.location.href = sortableR[0][0] + "?mode=diag&prenom=" + this.customerData.prenom;
                }, 200); */
                this.track(url, this.customerData.email, objToSend);
            }
        }
    }

    async track(url, email, obj) {
        /*
        var identify = await _learnq.push(['identify', {'$email': email }]); 
        var track = await _learnq.push(['track', 'typeform-diag', obj ]);  
        if(track){
            window.location.href = url;
        }
        */
        var objToString = "";
        Object.entries(obj).forEach((field, index) => {
            objToString += `"${field[0]}" : "${field[1]}"`;
            if (index < Object.entries(obj).length - 1) {
                objToString += ","
            }
        });


        const options = {
            method: 'POST',
            headers: {
                Accept: 'text/html',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                data: `{
                    "token": "KLbauE", 
                    "event": "typeform-diag", 
                    "customer_properties": {
                        "$email": "${email}"
                    },
                    "properties": {
                        ${objToString}
                    }
                }`
            })
        };
        const trackK = await fetch('https://a.klaviyo.com/api/track', options);
        if (trackK.ok) {
            window.location.href = '/pages/diagnostic-confirmation';
        }
    }
};

const smzDiag = new SmzDiag();